import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@shoflo/polymer/components/Button/Button';
import { Input } from '@shoflo/polymer/components/Input/Input';
import { InputLabel } from '@shoflo/polymer/components/InputLabel/InputLabel';
import { UserValidator } from '@shoflo/polymer/validators/UserValidator/UserValidator';
import { useForm, useFormState } from 'react-hook-form';
import { Form, FormGroup } from 'reactstrap';
import styled from 'styled-components';

import { resendInviteToken } from 'actions/user';

const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const InvalidInviteTokenForm = () => {
  const dispatch = useDispatch();
  const inviteResent = useSelector((state) => state.inviteResent);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const { control, register, handleSubmit } = useForm({
    mode: 'all',
  });
  let submitText = !isSubmitting ? 'Send email' : 'Sending...';
  if (inviteResent) submitText = 'Sent';

  const { errors, isValid } = useFormState({ control });

  return (
    <Form
      onSubmit={handleSubmit(async ({ email }) => {
        setIsSubmitting(true);
        dispatch(resendInviteToken(email));
      })}
    >
      <FormGroup>
        <InputLabel for="email">Email</InputLabel>
        <Input
          disabled={isSubmitting}
          id="email"
          name="email"
          data-testid="email-input"
          placeholder="e.g. tim.berg@gmail.com"
          error={errors.email}
          {...register('email', {
            validate: {
              invalid: (val) =>
                UserValidator.email(val) || 'Uh oh! Email is invalid',
            },
          })}
          autoComplete="email"
        />
      </FormGroup>
      <StyledButtonContainer>
        <Button type="submit" disabled={!isValid || isSubmitting}>
          {submitText}
        </Button>
      </StyledButtonContainer>
    </Form>
  );
};

InvalidInviteTokenForm.propTypes = {};

export default InvalidInviteTokenForm;
